module.exports = __webpack_public_path__ + "static/media/home-service-slider-9.02a1b97b.jpg";